<template>
  <div id="index">
    <dv-full-screen-container class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <router-link to='/'>
          <div class="d-flex jc-center">
            <img src="../assets/top.png" width="100%"/>
          </div>
        </router-link>
        <!-- 第二行 -->
        <div class="d-flex jc-between px-2" style="position: relative;
    margin-top: -1rem;z-index: -1">
          <div class="d-flex" style="width: 40%">
            <div
                class="react-left mr-4"
                style="width: 6.25rem;text-align: left"
            >
              <span class="react-after"></span>
             <h2 class="text" style="color: #4c9bfd">易智商城</h2>
            </div>
          </div>
          <div style="width: 40%" class="d-flex">
            <div class="react-left  mr-3">
<!--              <span class="text fw-b">vue-big-screen</span>-->
            </div>


            <div
              class="react-left mr-4"
              style="width: 6.25rem;text-align: right;"
            >
              <span class="react-after"></span>
              <span class="text">{{dateYear}} {{dateWeek}} {{dateDay}}</span>
            </div>
          </div>
        </div>

        <div class="body-box">
          <!-- 第一列数据 -->
          <div class="content-box">
            <div class="column3">
              <div class="bg-border" style="height:25vh">
                <div class="bg-border-inner" >
                   <Dynamics/>
                </div>
              </div>
              <div class="bg-border" style="height:30vh">
                <div class="bg-border-inner" >
                  <Cumulative/>
                </div>
              </div>
              <div class="bg-border" style="height: 30vh">
                <div class="bg-border-inner" >

                  <MallNum/>
                </div>
              </div>
            </div>
            <!-- 第二列数据 -->
            <div class="column4">
              <div style="height:60vh">
                <Map/>
              </div>

<!--              <div class="bg-border" style="height: 28vh">-->
<!--                <div class="bg-border-inner" >-->
<!--                  <Product/>-->
<!--                </div>-->
<!--              </div>-->
                            <div class="bg-border" style="height: 28vh">
                              <div class="bg-border-inner" >
                                <TotalAmount/>
                              </div>
                            </div>
            </div>
            <!-- 第三列数据 -->
            <div class="column3">
              <div class="bg-border" style="height: 32vh">
                <div class="bg-border-inner" >
                  <Ranking/>
                </div>
              </div>
              <div class="bg-border" style="height: 28vh">
                <div class="bg-border-inner" >
                  <Service/>
                </div>
              </div>
              <div class="bg-border" style="height: 25vh">
                <div class="bg-border-inner" >
                  <Product/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import { formatTime } from '../utils/index.js'
import Map from "@/components/mall/map";
import Cumulative from "@/components/mall/cumulative";
import TotalAmount from "@/components/mall/totalAmount";
import MallNum from "@/components/mall/mallNum";
import Service from "@/components/mall/service";
import Dynamics from "@/components/mall/dynamics";
import Ranking from "@/components/mall/ranking";
import Product from "@/components/mall/product";
export default {
  data () {
    return {
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    };
  },
  components: {
    Dynamics,//交易动态
    Map,//地图
    Service,//服务机构，产品
    Ranking,//排行榜
    Product,//产品数量
    Cumulative,//累计交易金额
    MallNum,//累计交易笔数
    TotalAmount,//总交易
  },
  watch:{
    typeList:{
      handler() {
        this.region=this.typeList.name
        this.$store.commit('setregion',this.region)
      }
    }
  },
  computed:{
    typeList(){
      return this.$store.state.typeList
    }

  },
  mounted () {
    this.timeFn();
    this.cancelLoading();
    this.$store.commit('setcdata',
   [
          {
            name: "渝北区",
            value: 99,
          },
          {
            name: "万州区",
            value: 3
          },
          {
            name: "黔江区",
            value: 8
          },
          {
            name: "涪陵区",
            value: 7
          },
          {
            name: "渝中区",
            value:100
          },
          {
            name: "大渡口区",
            value: 100
          },
          {
            name: "江北区",
            value: 100
          },
          {
            name: "沙坪坝区",
            value: 100
          },
          {
            name: "九龙坡区",
            value: 100
          },
          {
            name: "南岸区",
            value: 100
          },
          {
            name: "北碚区",
            value: 100
          },
          {
            name: "綦江区",
            value: 7
          },
          {
            name: "大足区",
            value: 6
          },

          {
            name: "巴南区",
            value: 99
          },
          {
            name: "长寿区",
            value: 2
          },
          {
            name: "江津区",
            value: 1
          },
          {
            name: "合川区",
            value: 3
          },
          {
            name: "永川区",
            value: 6
          },
          {
            name: "南川区",
            value: 7
          },
          {
            name: "璧山区",
            value: 9
          },
          {
            name: "铜梁区",
            value: 7
          },
          {
            name: "潼南区",
            value: 99
          },
          {
            name: "荣昌区",
            value: 4
          },
          {
            name: "开州区",
            value: 99
          },
          {
            name: "梁平区",
            value: 99
          },
          {
            name: "武隆区",
            value: 6
          },
          {
            name: "城口县",
            value: 2
          },
          {
            name: "丰都县",
            value: 8
          },
          {
            name: "垫江县",
            value: 7
          },
          {
            name: "忠县",
            value: 3
          },
          {
            name: "云阳县",
            value: 5
          },
          {
            name: "奉节县",
            value: 2
          },
          {
            name: "巫山县",
            value: 8
          },
          {
            name: "巫溪县",
            value: 5
          },
          {
            name: "石柱县",
            value: 9
          },
          {
            name: "秀山县",
            value: 1
          },
          {
            name: "酉阳县",
            value: 9
          },
          {
            name: "彭水县",
            value: 1
          }]
      )
  },
  methods: {
    timeFn () {
      setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss');
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd');
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000)
    },
    cancelLoading () {
      setTimeout(() => {
        this.loading = false;
      }, 200);
    }
  }
};
</script>

<style lang="scss">
@import '../assets/scss/index.scss';
.btnList{
  padding: 0.4rem;
  width: 100%;
  margin: 0!important;
}
.btnList .grid-content{
  //float: left;
  //width: 50%;
  height: 1.6rem;
  flex: 1;
  text-align: center;
  font-size: 20px;
  background: #142957;
  margin-bottom: 20px;
  padding-top: 0.3rem;
  border-radius: 0 0.2rem 0 0;
  color:#4c9bfd
}
.btnList .grid-content.active{
  background:#4169E1;
  color: #fff;
}
.btnList .grid-content:hover{
  background:#4169E1;
  color: #fff;
}
.grid-content i{
  width: 100%;
  margin-bottom: 10px;
  font-size: 48px!important;
}
.btnList .grid-content:nth-child(11){
  margin-bottom: 0;
}
</style>